import axiosInstance from "./axiosInstance";
import {
  ApproveWorkflowRequest,
  ApproveWorkflowResponse,
} from "../types/approveViewPostReqRes";

export const approveViewPostApi = async (
   payload: ApproveWorkflowRequest | ApproveWorkflowRequest[]
): Promise<ApproveWorkflowResponse> => {
  const response = await axiosInstance.post<
    ApproveWorkflowResponse
  >("/api/approver-view", payload);

  return response.data;
};
